import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  XrkTableProps,
  XrkTableRef,
  BaseTable,
  BaseIcon,
  BaseButton,
  BaseToolTip
} from 'xrk-components';
import { dealTableColumnstextLineClamp } from '../../tools/index';
import { Product } from '../../data-source/types';
import { ref, nextTick, watch } from 'vue';
import Sortable from 'sortablejs';
import { Sort } from '@element-plus/icons-vue';
import { ProductTableColumns } from './index';
import { cloneDeep } from 'lodash';

type ColumnsType = Product['row'];
type TableConfig = XrkTableProps<{}, ColumnsType>;

const DragButtonClassName = 'xrk-table--drag__btn';
const DragDisabledClassName = 'xrk-table--drag__disabled';

export default /*#__PURE__*/_defineComponent({
  __name: 'config-product',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emits = __emit;

const { TableRef, TableDomRef } = (() => {
  const TableDomRef = ref<HTMLDivElement>();
  const TableRef = ref<XrkTableRef>();
  return { TableRef, TableDomRef };
})();

const _data = ref<Array<ColumnsType>>([]);
const _dataIdSort = ref<Array<number>>([]);
const setDataSort = () => {
  _dataIdSort.value = [];
  _data.value.forEach((row, index) => {
    _dataIdSort.value[index] = row.id;
  });
};

const getSortData = (
  sortData: (typeof _dataIdSort)['value'],
  data: (typeof _data)['value']
) => {
  const map = data.reduce((map, row) => {
    map[row.id] = row;
    return map;
  }, {} as any);
  return sortData.map((id, index) => ({
    ...map[id],
    sort: index + 1
  }));
};

const tableConfig: TableConfig['tableConfig'] = {
  baseConfig: {
    height: 400,
    rowKey: 'productId'
  },
  tableColumns: dealTableColumnstextLineClamp<
    TableConfig['tableConfig']['tableColumns']
  >([
    ...ProductTableColumns,
    {
      width: 80,
      label: '排序',
      formatter: ({ row }) => _dataIdSort.value.indexOf(row.id) + 1
    },
    {
      width: 100,
      label: '操作',
      render: ({ row }) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 24,
              justifyContent: 'center'
            }}
          >
            <BaseButton
              type="text"
              disabled={props.disabled}
              click={() => {
                _dataIdSort.value.splice(_dataIdSort.value.indexOf(row.id), 1);
                _data.value = getSortData(
                  _dataIdSort.value,
                  _data.value.filter(item => item.id !== row.id)
                );
              }}
            >
              移除
            </BaseButton>
            <BaseToolTip
              type="text"
              content="拖动排序"
              disabled={props.disabled}
            >
              <BaseButton
                style={props.disabled ? '' : 'cursor:grab'}
                disabled={props.disabled}
                link
                class={props.disabled ? '' : DragButtonClassName}
              >
                <BaseIcon color={'var(--xrk-color-primary2)'}>
                  <Sort />
                </BaseIcon>
              </BaseButton>
            </BaseToolTip>
          </div>
        );
      }
    }
  ])
};
const initSortable = () => {
  const getDisabledDragParent = (el: HTMLElement) => {
    if (el.classList.contains(DragDisabledClassName)) {
      return el;
    }
    if (el.parentElement) {
      return getDisabledDragParent(el.parentElement);
    }
    return null;
  };
  const el = TableDomRef.value?.querySelector(
    '.xrk-table__body-wrapper tbody'
  ) as HTMLElement;
  if (el) {
    Sortable.create(el, {
      animation: 150,
      scroll: TableDomRef.value?.querySelector(
        '.xrk-scrollbar__wrap'
      ) as HTMLElement,
      scrollSensitivity: 30,
      handle: `.${DragButtonClassName}`,
      filter: `.${DragDisabledClassName}`,
      onEnd: ({ oldIndex, newIndex }) => {
        _dataIdSort.value.splice(
          newIndex as number,
          0,
          _dataIdSort.value.splice(oldIndex as number, 1)[0]
        );
        _data.value = getSortData(_dataIdSort.value, _data.value);
      },
      onMove: (_, originalEvent) => {
        const targetDOM = originalEvent.target as HTMLElement;
        return !getDisabledDragParent(targetDOM);
      }
    });
  }
};

watch(
  () => _data.value,
  newV => {
    emits('change', newV);
  },
  { deep: true }
);

__expose({
  pushData: (data: typeof _data.value) => {
    _data.value.push(...cloneDeep(data));
    setDataSort();
    nextTick(initSortable);
  },
  getAllData: () => getSortData(_dataIdSort.value, _data.value)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "TableDomRef",
    ref: TableDomRef
  }, [
    _createVNode(_unref(BaseTable), _mergeProps({
      ref_key: "TableRef",
      ref: TableRef,
      data: _data.value,
      columns: tableConfig.tableColumns
    }, tableConfig.baseConfig), null, 16, ["data", "columns"])
  ], 512))
}
}

})